// for now ignore the bad practice of using eval.
/*eslint no-new-func: 0*/
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import EntityProxy from "data/util/EntityProxy";
import entityMetaStore from "data/meta/entityMetaStore";
import PropTypes from "prop-types";
import RecordGridDataGateway, {
    buildColumnsFromConfig,
    buildCreatable,
} from "../RecordGridDataGateway";
import React from "react";

import Control
    from "lib/common/descriptorcontrols/CompositionField/summarysection";

export class CompositionFieldsummarysection extends React.Component {
    render() {
        const {
            controlOnly,
            descriptor,
            fluxContext,
            activeRecord,
            onFocus,
            onBlur,
            onKeyDown
        } = this.props;
        const config = descriptor.config || {};
        const creatables = [];
        if(!config.autoManaged) {
            for (let i = 0, l = config.creatables.length; i < l; i++) {
                const creatable = config.creatables[i];
                const ei = entityMetaStore.getInfo(creatable.key);
                creatables.push(buildCreatable(ei.implKey, creatable.name, creatable.key, creatable.collectionKey, activeRecord));
            }
        }

        const columns = buildColumnsFromConfig(config.columns, this.props);

        return (
            <RecordGridDataGateway
                key={descriptor.key}
                enabled={activeRecord.isFieldEnabled(descriptor.key)}
                component={Control}
                controlOnly={controlOnly}
                activeRecord={activeRecord}
                shortname={descriptor.key}
                singularLabel={config.otherEntityName}
                fluxContext={fluxContext}
                descriptor={descriptor}
                addMode={config.addMode}
                allowView={!config.inline}
                allowCreate={true}
                allowRemove={!config.autoManaged}
                columns={columns}
                creatables={creatables}
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
            />
        );
    }
}

CompositionFieldsummarysection.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes({
        inline: PropTypes.bool,
        autoManaged: PropTypes.bool,
        otherEntityName: PropTypes.string.isRequired,
        addMode: PropTypes.string.isRequired,
        columns: PropTypes.arrayOf(PropTypes.shape({
            heading: PropTypes.string.isRequired,
            width: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]).isRequired,
            type: PropTypes.string.isRequired,
            script: PropTypes.string,
            itemInfo: PropTypes.object,
        })).isRequired,
        creatables: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            key: PropTypes.string.isRequired,
            collectionKey: PropTypes.string.isRequired,
        })), // required, except if auto-managed
    })),
    fluxContext: PropTypes.string.isRequired,
    activeRecord: PropTypes.instanceOf(EntityProxy).isRequired,
    controlOnly: PropTypes.bool,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired
};

export default CompositionFieldsummarysection;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/CompositionField/summarysection.js